import "../Checkout/checkout.css";
import "../Login/CollectionEditor.css";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ImageUploader from './ImageUploader';
import { Button, Toast, Modal, Form, Accordion, Card } from 'react-bootstrap';

const CollectionList = () => {
    const [combos, setCombos] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalType, setModalType] = useState('add'); // "add" o "edit"
    const [comboEdit, setComboEdit] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [newCombo, setNewCombo] = useState({
        name: '',
        description: '',
        simple: '',
        doble: '',
        image: '',
        promocion: false,
    });

    useEffect(() => {
        cargarCombos();
    }, [refresh]);

    const cargarCombos = () => {
        axios.get('https://pedir-prueba.p89nps.easypanel.host/api/productos')
            .then(response => setCombos(response.data))
            .catch(error => console.error("Error al cargar combos:", error));
    };

    const handleOpenModal = (combo = null) => {
        setModalType(combo ? 'edit' : 'add');

        if (combo) {
            setComboEdit(combo);
            setNewCombo({
                name: combo.name,
                description: combo.description,
                simple: combo.simple,
                doble: combo.doble,
                image: combo.image || '',
                promocion: combo.promocion === 'si',
            });
        } else {
            setNewCombo({ name: '', description: '', simple: '', doble: '', image: '', promocion: false });
        }

        setModalShow(true);
    };

    const agregarCombo = async () => {
        const nuevoCombo = {
            categoryId: "combos",
            name: newCombo.name,
            description: newCombo.description,
            simple: newCombo.simple,
            doble: newCombo.doble,
            image: newCombo.image,
            promocion: newCombo.promocion ? "si" : "no"
        };

        try {
            const response = await axios.post('https://pedir-prueba.p89nps.easypanel.host/api/productos', nuevoCombo);
            if (response.status === 201) {
                setShowToast(true);
                setRefresh(prev => !prev);
                setModalShow(false);
            }
        } catch (error) {
            console.error("Error al agregar combo:", error);
            alert("Hubo un problema al agregar el combo.");
        }
    };

    const modificarCombo = async () => {
        if (!comboEdit) return;

        const updates = [
            { field: 'name', value: newCombo.name },
            { field: 'description', value: newCombo.description },
            { field: 'simple', value: newCombo.simple },
            { field: 'doble', value: newCombo.doble },
            { field: 'promocion', value: newCombo.promocion ? 'si' : 'no' }
        ];

        try {
            for (const update of updates) {
                await axios.put(
                    `https://pedir-prueba.p89nps.easypanel.host/item/${comboEdit.id}/${update.field}`,
                    { [update.field]: update.value }
                );
            }

            setShowToast(true);
            setRefresh(prev => !prev);
            setModalShow(false);
        } catch (error) {
            console.error("Error al modificar el combo:", error);
            alert("Hubo un problema al modificar el combo.");
        }
    };

    const eliminarCombo = async (id) => {
        try {
            await axios.delete(`https://pedir-prueba.p89nps.easypanel.host/api/productos/${id}`);
            setRefresh(prev => !prev);
            setShowToast(true);
        } catch (error) {
            console.error("Error al eliminar el combo:", error);
        }
    };

    return (
        <>
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header><h4>Combos</h4></Accordion.Header>
                    <Accordion.Body>
                        <Button variant="primary" onClick={() => handleOpenModal()}>➕ Agregar Combo</Button>
                        <br /><br />
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                            {combos.length === 0 ? (
                                <p>No hay combos cargados.</p>
                            ) : (
                                combos.map((combo) => (
                                    <Card key={combo.id} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '8px', textAlign: 'center', backgroundColor: 'white' }}>
                                        {combo.image && <Card.Img variant="top" src={combo.image} alt={combo.name} style={{ height: '150px', objectFit: 'cover' }} />}
                                        <Card.Body>
                                            <Card.Title>{combo.name}</Card.Title>
                                            <Card.Text>{combo.description}</Card.Text>
                                            <Card.Text><b>Simple:</b> ${combo.simple} | <b>Doble:</b> ${combo.doble}</Card.Text>
                                            <Card.Text><b>Promoción:</b> {combo.promocion === 'si' ? '✅ Sí' : '❌ No'}</Card.Text>
                                            <Button variant="warning" size="sm" onClick={() => handleOpenModal(combo)}>✏️ Modificar</Button>{' '}
                                            <Button variant="danger" size="sm" onClick={() => eliminarCombo(combo.id)}>🗑️ Eliminar</Button>
                                        </Card.Body>
                                    </Card>
                                ))
                            )}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            {/* ✅ Modal para agregar/modificar combos */}
            <Modal show={modalShow} onHide={() => setModalShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? '➕ Agregar Combo' : '✏️ Modificar Combo'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                value={newCombo.name}
                                onChange={(e) => setNewCombo({ ...newCombo, name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Descripción</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={newCombo.description}
                                onChange={(e) => setNewCombo({ ...newCombo, description: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Precio Simple</Form.Label>
                            <Form.Control
                                type="number"
                                value={newCombo.simple}
                                onChange={(e) => setNewCombo({ ...newCombo, simple: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Precio Doble</Form.Label>
                            <Form.Control
                                type="number"
                                value={newCombo.doble}
                                onChange={(e) => setNewCombo({ ...newCombo, doble: e.target.value })}
                            />
                        </Form.Group>
                        {modalType === 'add' && (
                            <Form.Group className="mb-3">
                                <Form.Label>Imagen</Form.Label>
                                <ImageUploader onUploadComplete={(url) => setNewCombo({ ...newCombo, image: url })} />
                            </Form.Group>
                        )}
                        <Form.Group className="mb-3">
                            <Form.Label>¿Promoción?</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Sí"
                                checked={newCombo.promocion}
                                onChange={(e) => setNewCombo({ ...newCombo, promocion: e.target.checked })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModalShow(false)}>Cancelar</Button>
                    <Button variant="success" onClick={modalType === 'add' ? agregarCombo : modificarCombo}>
                        {modalType === 'add' ? 'Guardar Combo' : 'Guardar Cambios'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CollectionList;
